import { Box } from "@rebass/grid";
import {
  IContract,
  EContractIndexationStatus,
} from "@rentiohq/shared-frontend/dist/types/contract.types";
import {
  EPropertyMemberTypes,
  IProperty,
} from "@rentiohq/shared-frontend/dist/types/property.types";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { iHaveRole } from "@rentiohq/shared-frontend/dist/utils/roles.utils";
import {
  Button,
  DisplayText,
  Icon,
  RentioInternalRenderer,
  Stack,
} from "@rentiohq/web-shared/dist/components";
import { useInternalMode } from "@rentiohq/web-shared/dist/redux/system/system.hooks";
import { IChecklistItem } from "../ChecklistItem";
import * as S from "./IndexationCard.styled";

interface IProps {
  indexationItem: IChecklistItem;
  contract: IContract;
  property: IProperty;
}

export const IndexationCard = ({
  indexationItem,
  contract,
  property,
}: IProps) => {
  const { internalModeEnabled } = useInternalMode();

  const canIndex =
    contract.indexationStatus &&
    [
      EContractIndexationStatus.Ready,
      EContractIndexationStatus.OwnerAsked,
      EContractIndexationStatus.OwnerApproved,
    ].includes(contract.indexationStatus);

  const lacksIndexationRole =
    internalModeEnabled &&
    !iHaveRole(property, EPropertyMemberTypes.IndexationManager);
  return (
    <S.Card>
      <S.RoundedBorder />
      <S.Content>
        <S.Flex
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
        >
          <Box>
            <DisplayText size="extraSmall">
              {getLocalizedText("property.indexation_possible.label")}
            </DisplayText>

            <Stack spacing="tight" alignment="center">
              <Icon source="currencyEuroIncrease" />

              {lacksIndexationRole ? (
                <RentioInternalRenderer>
                  {getLocalizedText("property.indexation_possible.no_role")}
                </RentioInternalRenderer>
              ) : (
                <S.SectionSubtext>
                  {getLocalizedText(
                    `property.dashboard.checklist.index_contract.${contract.indexationStatus}.content`.toLowerCase(),
                  )}
                </S.SectionSubtext>
              )}
            </Stack>
          </Box>

          {canIndex && indexationItem?.onClick && (
            <Button
              size="small"
              color="yellow"
              onClick={indexationItem?.onClick}
            >
              {`${getLocalizedText("system.start")} ›`}
            </Button>
          )}
        </S.Flex>
      </S.Content>
    </S.Card>
  );
};
